import { useSeo } from "@/lib/seo";
import { PageHeader, Section, CTABanner } from "@/components/blocks";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Placeholder } from "@/components/Placeholder";

const FAQS = [
  {
    q: "How does the matching process work?",
    a: "You share your request through our form. The team reviews it personally and, when there's a good potential fit, introduces nannies with the context you need. Nothing is booked or confirmed automatically.",
  },
  {
    q: "What does it cost?",
    a: "We don't publish standard prices because every family's needs are different. The team will discuss fees after understanding the family's needs.",
  },
  {
    q: "Do you offer cleaning, maid or visa services?",
    a: "No. We focus solely on childcare matching. We don't provide cleaning, general maid, visa, immigration or payroll services.",
  },
  {
    q: "Do you guarantee a match or a response time?",
    a: "We can't make guarantees about outcomes or timing. We review every request carefully and reach out using your preferred contact method.",
  },
  {
    q: "How is my information handled?",
    a: "Every submission is stored securely and kept private to our team. It is not published, listed publicly or indexed by search engines. See our Privacy Policy for details.",
  },
  {
    q: "Can nannies apply directly?",
    a: "Yes. Experienced nannies can apply through the For Nannies page. Applications and any documents shared stay private to our team.",
  },
  {
    q: "How can I contact the team?",
    a: "We're setting up our business contact channels. Until then, the best way to reach us is through the Request a Nanny Match or nanny application forms.",
  },
];

export default function FAQ() {
  useSeo({
    title: "FAQ — Nanny Poppins UAE",
    description:
      "Answers to common questions about Nanny Poppins: how matching works, fees, privacy and what we do and don't offer.",
  });

  return (
    <div>
      <PageHeader
        eyebrow="FAQ"
        title="Questions, answered honestly."
        intro="If your question isn't here, reach out through one of our forms and the team will be glad to help."
      />

      <Section className="max-w-3xl">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-[#0B0A08]/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-serif text-lg tracking-tight hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-[#0B0A08]/70">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <p className="mt-8 text-sm text-[#0B0A08]/60">
          Office hours: <Placeholder>To be confirmed</Placeholder>
        </p>
      </Section>

      <CTABanner />
    </div>
  );
}
